<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" v-bind:class="className">
      <div class="modal-overlay" @click="back()"></div>
      <div class="modal">
        <article v-if="resource">
          <header>
            <figure><i class="icon icon-icon_layers"></i></figure>
            <div>
                            <span class="breadcrumb">
                                Attribute <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
              <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
            </div>
            <div class="spacer"></div>
            <div class="buttons">
              <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
              <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
            </div>
          </header>

          <main>

             <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

            <tabs :options="{ useUrlFragment: false }">
              <tab name="Information">

                <fieldset>
                  <h3>Détail</h3>
                  <p class="headline"></p>

                  <form-toggle label="Multilangues" v-model="resource.multilingual"></form-toggle>

                  <form-select label="Parent attribute" multiple="false" v-model="resource.parent" :default="resource.parent_id" :options="attributes"></form-select>

                  <form-text :label="'slug'" v-model="resource.slug" :required="true"></form-text>

                  <form-select label="Type" multiple="false" v-model="resource.type" :default="resource.type" :options="types" :required="true"></form-select>

                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                      <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                    </div>
                  </div>

                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                      <form-html :translate-key="'description'" :translations="resource.translations" :lang="client.id" label="Content" v-model="resource.translations[client.id].description"></form-html>
                    </div>
                  </div>

                  <form-checklist :label="'Models'" v-model="resource.models" :options="models" :multiple="true"></form-checklist>

                </fieldset>
              </tab>
              <tab name="Avancé">
                <fieldset>
                  <h3>Paramètres de produits</h3>
                  <p class="headline"></p>

                  <form-toggle label="Attribut de produit" v-model="resource.allowed_for_products"></form-toggle>
                  <form-toggle label="Allow import from products" v-model="resource.add_on_import"></form-toggle>

                </fieldset>

                <fieldset>
                  <h3>Paramètres complémentaires</h3>
                  <p class="headline"></p>

                  <div v-if="$aclInterfaceValidator('is_super_admin')">
                    <form-toggle label="Global à tous les clients" v-model="resource.is_global"></form-toggle>
                  </div>

                  <form-text :label="'Caractère de séparation'" v-model="resource.separator" hint="Par défaut, une virgule est utilisée pour séparer les attributs sur le site"></form-text>

                </fieldset>
              </tab>
              <tab name="Values" v-if="resource.type && resource.type.id != 'text' && resource.type.id != 'file'">


                <fieldset>
                  <h3>Valeurs</h3>
                  <p class="headline"></p>

                  <div class="table">
                    <div>
                      <div>
                        <div>Slug</div>
                        <div>Valeur</div>
                        <div>Description</div>
                        <div>Color</div>
                        <div>Picture</div>
                        <div>Default</div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>

                    <draggable v-model="resource.values" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}">
                      <div v-for="(value, index) in resource.values" v-show="resource.values">
                        <div><input type="text" v-model="value.slug"/></div>
                        <div>
                          <div v-for="client in locales" v-if="localesLoaded" v-show="client.id == locale || locale == 'all'">
                            <input type="text" v-model="value.translations[client.id].name"/>
                            <img :src="'/src/assets/flags/'+client.id+'.svg'" class="flag">
                          </div>
                        </div>
                        <div>
                          <div v-for="client in locales" v-if="localesLoaded" v-show="client.id == locale || locale == 'all'">
                            <input type="text" v-model="value.translations[client.id].description"/>
                            <img :src="'/src/assets/flags/'+client.id+'.svg'" class="flag">
                          </div>
                        </div>
                        <div>
                          <input type="text" v-model="value.value"/>
                        </div>
                        <div>
                          <form-file v-model="value.picture_id" width="60"></form-file>
                        </div>
                        <div>
                          <div>
                            <!--<form-toggle label="" v-model="value.is_default" :index="index" @event="updateDefaultValue"></form-toggle>-->
                            <input type="radio" name="default" v-model="value.is_default" :value="1" @change="updateDefaultValue(index)"/>
                          </div>
                        </div>
                        <div>
                          <button @click="removeValue(value)" class="btn remove"><span class="icon icon-icon_close"></span></button>
                        </div>
                        <div class="drag">
                          <i class="icon icon-drag"></i>
                        </div>
                      </div>
                    </draggable>
                  </div>

                  <div class="footer-buttons">
                    <button @click="addValue()" class="btn"><span>Ajouter</span></button>
                  </div>

                </fieldset>

              </tab>
            </tabs>

          </main>
        </article>

      </div>
    </div>
  </transition>
</template>
<script>

import AttributeService from './AttributeService.js';
import Edit from '../../../layouts/Edit.vue';

export default {
  extends: Edit,
  data () {
    return {
      config: null,
      options: [],
      types: [
        {id:'color', name:'Color'},
        {id:'select', name:'Select'},
        {id:'list', name:'List'},
        {id:'radio', name:'Radio'},
        {id:'country', name:'Country'},
        {id:'phone', name:'Phone'},
        {id:'email', name:'Email'},
        {id:'text', name:'Text'},
        {id:'textarea', name:'Textarea'},
        {id:'html', name:'Html'},
        {id:'file', name:'file'},
        {id:'toggle', name:'Toggle'}
      ],
      models: [
        {id:'Maven\\WeeboxCore\\Models\\Person', name:'Person'},
        {id:'Maven\\WeeboxCore\\Models\\Company', name:'Company'},
        {id:'Maven\\WeeboxCore\\Models\\Audience', name:'Audience'},
        {id:'Maven\\WeeboxCore\\Models\\Scope', name:'Scope'},
        {id:'Maven\\WeeboxShop\\Models\\Product', name:'Product'},
        {id:'Maven\\WeeboxShop\\Models\\Category', name:'Category'},
        {id:'Maven\\WeeboxShop\\Models\\Brand', name:'Brand'}
      ],
      attributes: []
    }
  },
  mounted: function(){

    AttributeService.all().then(response => {
      this.attributes = []
      this.isLoading = false

      for(let item of response.data){
        if( !item.parent_id && item.id != this.resource.id ){
          this.attributes.push(item)
        }
      }

    })

  },
  methods:{
    updateDefaultValue: function(index){
      let checked = this.resource.values[index].is_default;
      for( var i=0; i<this.resource.values.length ; i++){
        this.resource.values[i].is_default = false;
      }
      this.resource.values[index].is_default = checked;
    },
    addValue: function(){
      let data = {
        id: null,
        slug: "",
        is_default: 0
      };
      this.setTranslationsTo(data, ['name','description']);
      this.resource.values.push(data);

      this.$forceUpdate();
      console.log('data', data);
    },
    removeValue: function(value){
      //console.log(value)
      let index = null
      for( var i=0; i<this.resource.values.length ; i++){
        if( value == this.resource.values[i] ){
          index = i
        }
      }
      if( index != null ){ this.resource.values.splice(index,1); }
    },
    resourceLoaded: function(){
      this.setTranslations(['name','description']);

      this.resource.is_global = this.resource.is_global;

      this.resource.values = this.resource.values || [];

      if( this.resource.values ){
        for( var i=0; i<this.resource.values.length ; i++){
          this.setTranslationsTo(this.resource.values[i], ['name','description']);
        }
      }
      this.resource.models = this.resource.modelsByScope ? this.resource.modelsByScope : []

      this.initialize()
    },
    getResource: function(){
      return AttributeService
    },
    beforeUpdate: function(Resource){
      return true;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/modules/config/attribute/Edit.vue